export default {
    'OPERACION_CARTA': (state, mutation) => {
        state.operacion = mutation.oper
        state.carta = mutation.carta
    }
}